import { FC, PropsWithChildren } from 'react';

import { TimeTextStyled } from './styled';

export type TTimeTextVariant =
	| 'fixed'
	| 'nonfixed'
	| 'intermediate'
	| 'old'
	| 'effective';

interface ITimeTextProps {
	variant?: TTimeTextVariant;
}

export const TimeText: FC<PropsWithChildren<ITimeTextProps>> = ({
	children,
	variant = 'fixed',
}) => {
	return (
		<TimeTextStyled className="maybeDisabled" ownerState={{ variant }}>
			{variant === 'nonfixed' && '≈'}
			{children}
		</TimeTextStyled>
	);
};
